import * as React from 'react';
import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';

import { LayoutWrapper } from '../../layouts';
import { getServerTranslations } from '../../lib/i18n/getServerTranslations';
import WorkerApplicationFormWizard from '../../components/worker-application-wizard';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IWorkerApplicationProps {}
export const WorkerApplication: React.FunctionComponent<IWorkerApplicationProps> = () => <MainComponent />;

const MainComponent = () => {
  const { t } = useTranslation('common');
  return (
    <LayoutWrapper title={t('candidates')} noHorizontalPadding noPaddingBottom noPaddingTop>
      <WorkerApplicationFormWizard />
    </LayoutWrapper>
  );
};
export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const transConfig = await getServerTranslations(locale, ['common', 'onboarding-page']);
  return {
    props: {
      ...transConfig,
    },
  };
};
export default WorkerApplication;
